import { Form, InputNumber, DatePicker, Input, Button, Row, Col, Tabs, message, Modal, TimePicker } from 'antd';
import { useState, useEffect, forwardRef, useImperativeHandle }  from 'react';
import CustomSelect  from './CustomSelect.jsx';
import CustomCheckbox  from './CustomCheckbox.jsx';
import axiosInstance from './axiosInstance.js';
import moment from 'moment';
import './Form.css'
import {tabitem,handleException, getval, formitems} from './Utils.jsx'
import {rightitems} from './defs.js'
const { TabPane } = Tabs;
const { TextArea } = Input;


function FormSetting({entity="TSetting", recid  = 'credits', writeRight, ...props}) {
    const [form] = Form.useForm();
    //const recid  = 'credits';
    const [loading, setLoading] = useState(true);    
    const url = '/dataservice'
    const urlsave = {
        credits : '/creditsettingsave',
        assign_hours : '/settingsave',
        mails : '/settingsave',
    }[recid]

    const items = { 
        credits : [   
            {name:"interval",     label:"Perioda [min]",required:true,ctrl: (pp)=>(<InputNumber {...pp} min={1} max={10000} />)},
            null,
            {name:"increment",    label:"Přídavek",required:true,   ctrl: (pp)=>(<InputNumber {...pp} min={0} max={100} />)},
            {name:"max",          label:"Max",required:true,   ctrl: (pp)=>(<InputNumber {...pp} min={0} max={1000} />)},
        ],

        assign_hours : [     
            {name:"assign_hour_fr",  label:"Hodina Od",required:false,   ctrl: (pp)=>(<InputNumber min={0} max={23} {...pp} />)},
            {name:"assign_hour_to",    label:"Hodina Do",required:false,   ctrl: (pp)=>(<InputNumber min={0} max={23} {...pp} />)},
        ],

        mails : [     
            {name:"admin_mail",          label:"Mail administrátora",  required:true,         ctrl: (pp)=>(<Input {...pp} />)},
            null,
            {name:"app_mail",            label:"Mail aplikace",        required:true,           ctrl: (pp)=>(<Input {...pp} />)},
            {name:"app_mail_password",   label:"Mail aplikace - Heslo",required:true,     ctrl: (pp)=>(<Input.Password {...pp} />)}, 
            {name:"smtp_server_address", label:"Smtp server - Adresa", required:true, ctrl: (pp)=>(<Input {...pp} />)},
            {name:"smtp_server_port",    label:"Smtp server - Port",   required:true,   ctrl: (pp)=>(<InputNumber {...pp} />)},
        ]
    }[recid]
    
    useEffect(() => { loadData(recid) },[])

    function translate(r,dir){
        if(!r) return r;
        if(dir == 0) {
            return r.data  
        } else { 
            return {name: recid, data:r}
        }
    }

    async function loadData(recid) { 
		//setRecid(recid)
        setLoading(true);	
        try {
			let response = await axiosInstance.post(url, {cmd:'get-record',entity:entity,recid:recid});
            var r = response.data.record
            r = translate(r,0)  
            form.setFieldsValue(r);        
		} catch (err) {  
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    async function saveData() {
		setLoading(true);
		try {
			const response = await axiosInstance.post(urlsave, {recid:recid, ...translate(form.getFieldsValue(),1)});
            message.success('Záznam byl úspěšně uložen');
            console.log(response)
		} catch (err) {
            handleException(err)
		} finally {
			setLoading(false);
		}
	};

    function handleChange(changedValues, allValues) { 
        //console.log('allvalues',allValues)
        console.log('changedvalues',changedValues)          
    };

    function handleFinish(values){
        console.log('Form Values:', values);
        saveData();
    };
    
    return (
        <div>
        <Form
            form={form}
            name={'settingForm'}
            labelCol={{ span: 12 }}
            onFinish={handleFinish}
            onValuesChange={handleChange}
            disabled={!writeRight}
            {...props}
        >           
            {formitems(items,{},{},2)}
            
            <Form.Item wrapperCol={{ offset: 10, span: 24 }}>
                <Button type="primary" htmlType="submit">Uložit</Button>
            </Form.Item>
        </Form>
        </div>
    )
}

export default FormSetting;





